<template>
  <ul style="display: none;">
    <li v-for="({src}) in files">
      <img :src="src|ossThumbnail(75)"
           :alt="src"
           ref="img"/>

    </li>
  </ul>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'

// View an image
let viewer = null

export default {
  components: {},
  props: {},
  data () {
    return {
      visible: false,
      action: '',
      files: [],
      index: null,
    }
  },
  computed: {},
  watch: {
    visible () {
      if (this.visible) {
        this.view(this.index)
      }
    },
  },
  created () {},
  mounted () {},
  destroyed () {
    this.destroyViewer()
  },
  methods: {
    view (index) {
      this.$nextTick(() => {
        this.createViewer()
        viewer.view(index)
        viewer.show()
      })
    },
    createViewer () {
      this.destroyViewer()
      viewer = new Viewer(this.$el, {
        url: (image) => `${image.alt}?x-oss-process=image/auto-orient,1`,
        hidden: this.onClose,
      })
    },
    destroyViewer () {
      viewer && viewer.destroy()
    },
    handleAction (action) {
      this.action = action
      this.doClose()
    },
    onClose () {
      if (!this.visible) return
      this.handleAction('close')
    },
    doClose () {
      if (!this.visible) return
      this.visible = false
      setTimeout(() => {
        if (this.action) this.callback(this.action, this)
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/image-view-box/src/main.vue